<div class="ward-settings-container">
    <div class="action-heading">
        <h3>Wards</h3>
        <button mat-icon-button (click)="addWard()" matTooltip="Add a new ward"
            color="primary"><mat-icon>add</mat-icon></button>
    </div>
    <div *ngFor="let ward of wards; let i = index" class="ward-section">
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Ward {{ i + 1 }}</mat-label>
            <input matInput [(ngModel)]="ward.name">
        </mat-form-field>
        <!--  <mat-form-field appearance="outline" class="full-width">
            <mat-label>Auto Coding Procedure Code</mat-label>
            <input matInput [(ngModel)]="ward.procedureCode">
            <button matSuffix mat-icon-button matTooltip="Click for more information about user roles"
                aria-label="Information about auto codes" (click)="openInfoDialog($event)">
                <mat-icon>info</mat-icon>
            </button>
        </mat-form-field> -->

        <button mat-icon-button color="warn" (click)="removeWard(ward)" class="m-b-20">
            <mat-icon>delete</mat-icon>
        </button>
    </div>
</div>